import React from 'react';
import { FormControl, Grid, IconButton, InputLabel, MenuItem, Select } from '@mui/material';
import { ArrowDownward, ArrowUpward, KeyboardArrowDown } from '@mui/icons-material';

import { useCCTableContext } from '../cc-table.context';

export const CCTableSorter = () => {
  const { columns, order, orderBy, updateTableStatus } = useCCTableContext();
  const label = 'Sort by : ';

  const onRequestSort = (property: string) => {
    const isAsc = orderBy === property && order === 'asc';

    updateTableStatus({ order: isAsc ? 'desc' : 'asc', orderBy: property });
  };

  return (
    <Grid container spacing={2} sx={{ alignItems: 'center' }}>
      <Grid item sx={{ flex: 1 }}>
        <FormControl fullWidth>
          <InputLabel>{label}</InputLabel>

          <Select
            label={label}
            value={orderBy === null ? '' : orderBy}
            onChange={(event) => onRequestSort((event.target.value || '') as string)}
            IconComponent={({ sx, ...rest }) => <KeyboardArrowDown sx={{ ...sx, marginRight: 1 }} {...rest} />}
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>

            {columns
              .filter(({ sorter }) => sorter !== false)
              .map(({ id, label }, index) => {
                return (
                  <MenuItem key={`sort-item-${index}`} value={id}>
                    {label}
                  </MenuItem>
                );
              })}
          </Select>
        </FormControl>
      </Grid>

      {orderBy && (
        <Grid item>
          <IconButton color="primary" onClick={() => updateTableStatus({ order: order === 'asc' ? 'desc' : 'asc' })}>
            {order === 'asc' ? <ArrowUpward /> : <ArrowDownward />}
          </IconButton>
        </Grid>
      )}
    </Grid>
  );
};
